import React from 'react';
import { VehicleProfile } from '../../../types/Vehicle';
import { OverlayTrigger, Popover, Row, Col } from '@/components/ui';

interface VehicleProfilePreviewProps {
  profile: VehicleProfile | null | undefined;
}

const VehicleProfilePreview: React.FC<VehicleProfilePreviewProps> = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const popover = (
    <Popover id="profile-preview-popover" style={{ maxWidth: '400px' }}>
      <Popover.Header as="h6">{profile.inspection} - Profile Details</Popover.Header>
      <Popover.Body>
        <Row>
          <Col xs={6}>
            <p className="tw-mb-1"><strong>Vehicle Type:</strong></p>
            <p className="tw-mb-2">{profile.vehicleType || '-'}</p>

            <p className="tw-mb-1"><strong>Vehicle Classification:</strong></p>
            <p className="tw-mb-2">{profile.vehicleClassification || '-'}</p>

            <p className="tw-mb-1"><strong>PM Classification:</strong></p>
            <p className="tw-mb-2">{profile.pmClassification || '-'}</p>

            <p className="tw-mb-1"><strong>Odometer Alerts:</strong></p>
            <p className="tw-mb-2">{profile.odometerAlerts || '-'}</p>
          </Col>
          <Col xs={6}>
            <p className="tw-mb-1"><strong>Requirements:</strong></p>
            <ul className="tw-list-none tw-pl-0 tw-mb-2">
              <li>• Mandatory Odometer Picture: {profile.mandatoryOdometerPicture ? 'Yes' : 'No'}</li>
              <li>• Requires CVI Expiry Date: {profile.requiresCVIExpiryDate ? 'Yes' : 'No'}</li>
              <li>• Requires Odometer Reading: {profile.requiresOdometerReading ? 'Yes' : 'No'}</li>
              <li>• Requires Brake Inspection: {profile.requiresBrakeInspection ? 'Yes' : 'No'}</li>
              <li>• Requires Post-trip: {profile.requiresPostTrip ? 'Yes' : 'No'}</li>
              <li>• Requires Foreman Approval: {profile.requiresForemanApproval ? 'Yes' : 'No'}</li>
              <li>• Requires Mech Supervisor Approval: {profile.requiresMechSupervisorApproval ? 'Yes' : 'No'}</li>
            </ul>
            {profile.postTripThreshold && (
              <>
                <p className="tw-mb-1"><strong>Post-trip Threshold:</strong></p>
                <p className="tw-mb-0">{profile.postTripThreshold}</p>
              </>
            )}
          </Col>
        </Row>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="right"
      overlay={popover}
    >
      <i
        className="bi bi-info-circle tw-text-primary tw-ml-2"
        style={{ cursor: 'help' }}
        title="Hover to view profile details"
      ></i>
    </OverlayTrigger>
  );
};

export default VehicleProfilePreview;
